<template>
  <div>
    <q-dialog :visible="isVisible" :title="title" width="900px" :innerScroll="false" :showFooter="false" @close="onCancel">
      <div class="content">
        <el-table :data="tableData.list" border :height="380" style="width: 100%" v-loading="loading">
          <el-table-column prop="updatedBy" label="更新人" show-overflow-tooltip width="120"></el-table-column>
          <el-table-column prop="updatedDate" label="更新时间" show-overflow-tooltip width="180"></el-table-column>
          <el-table-column prop="modifyFieldDesc" label="更新字段" show-overflow-tooltip width="120"></el-table-column>
          <el-table-column prop="beforeModify" label="变更前" width="150"></el-table-column>
          <el-table-column prop="afterModify" label="变更后"></el-table-column>
        </el-table>
        <div height="auto" style="text-align: right; padding-top: 10px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </div>
    </q-dialog>
  </div>
</template>

<script>
export default {
  name: "storeClearance",
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: Object,
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return "调整记录";
    },
  },
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
    };
  },
  methods: {
    init() {
      this.loading = true;
      let data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: '82'
      }
      this.$q.newProduct.commissionCalculateModifyRecordPage({data: data})
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onCancel() {
      this.isVisible = false;
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="stylus" scoped>
</style>
